/**
 * "Owns" chips — the tools this agent is the routing owner of (#46 §1).
 *
 * OWNERSHIP NEVER WIDENS PERMISSION. A row with `permitted: false` is
 * rendered "owned, cannot act yet" and drawn as the gate it is, because
 * the alternative — hiding it, or showing it like any other tool — would
 * imply an ability the platform deliberately withholds.
 */

import type { OwnershipRow } from '../../types/agentMind';
import styles from './workspace.module.css';

export function OwnsChips({ rows }: { rows: OwnershipRow[] }) {
  if (rows.length === 0) {
    return (
      <div className={styles.subtle}>This agent owns no tools yet.</div>
    );
  }
  return (
    <div className={styles.quietRow}>
      {rows.map((row) => (
        <span
          key={row.tool_key}
          className={`${styles.chip} ${row.permitted ? '' : styles.chipGated}`}
          data-testid={`owns-chip-${row.tool_key}`}
          title={row.reason ?? undefined}
        >
          {row.display_name || row.tool_key}
          {row.permitted ? null : <> · owned, cannot act yet</>}
        </span>
      ))}
    </div>
  );
}
